// src/slices/shipcomapany/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getShipCompanies = createAsyncThunk("shipCompany/getAll", async (_, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/ship-company/all`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});

// GET ONE
export const getShipCompanyOne = createAsyncThunk("shipCompany/getOne", async (id, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/ship-company/one`, { params: { identifier: id } });

    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || err.message);
  }
});
